export default __webpack_public_path__ + "static/media/back-icon.8d6fb8b7.svg";